import {
  Sparkles,
  MessageCircle,
  CalendarCheck,
  UserCheck,
  CheckCircle2,
  FileText,
  DollarSign,
  Archive,
  XCircle,
  AlertTriangle,
} from "@/lib/icons";

// Orden de estados del pipeline - USANDO NUEVOS VALORES DE DB
export const STATUS_ORDER = [
  "nuevo",
  "contactado",
  "cita_solicitada",
  "cita",
  "interesado",
  "entrega_resultado",
  "pendiente_pago",
  "inscrito",
  "perdido",
  "spam",
];

// Etiquetas legibles
export const STATUS_LABELS = {
  nuevo: "Primer Contacto",
  contactado: "Proceso",
  cita_solicitada: "Solicita cita",
  cita: "Cita Agendada",
  interesado: "Aplicar Examen",
  entrega_resultado: "Entrega de Resultado",
  pendiente_pago: "Pendiente de Pago",
  cierre: "Cierre de Inscripción",
  inscrito: "Inscrito",
  perdido: "Archivado",
  spam: "Spam",
};

// Iconos por estado
export const STATUS_ICONS = {
  nuevo: Sparkles,
  contactado: MessageCircle,
  cita_solicitada: AlertTriangle,
  cita: CalendarCheck,
  interesado: UserCheck,
  entrega_resultado: FileText,
  pendiente_pago: DollarSign,
  cierre: CheckCircle2,
  inscrito: Sparkles,
  perdido: Archive,
  spam: XCircle,
};

// Colores por estado (verde-azul-ámbar por proceso)
export const STATUS_COLORS = {
  nuevo: "#0ea5e9",
  contactado: "#3b82f6",
  cita_solicitada: "#d97706",
  cita: "#f59e0b",
  interesado: "#22c55e",
  entrega_resultado: "#10b981",
  pendiente_pago: "#f59e0b",
  cierre: "#7a1b33",
  inscrito: "#10b981",
  perdido: "#f87171",
  spam: "#94a3b8",
};

// Clases de badge por estado
export const STATUS_BADGE_CLASSES = {
  nuevo: "bg-sky-100 text-sky-700 dark:bg-sky-900/40 dark:text-sky-200",
  contactado:
    "bg-blue-100 text-blue-700 dark:bg-blue-900/40 dark:text-blue-200",
  cita_solicitada:
    "bg-amber-100 text-amber-700 dark:bg-amber-900/40 dark:text-amber-200",
  cita: "bg-amber-100 text-amber-700 dark:bg-amber-900/40 dark:text-amber-200",
  interesado:
    "bg-emerald-100 text-emerald-700 dark:bg-emerald-900/40 dark:text-emerald-200",
  entrega_resultado:
    "bg-emerald-100 text-emerald-700 dark:bg-emerald-900/40 dark:text-emerald-200",
  pendiente_pago:
    "bg-amber-100 text-amber-700 dark:bg-amber-900/40 dark:text-amber-200",
  cierre:
    "bg-rose-100 text-rose-700 dark:bg-rose-900/40 dark:text-rose-200",
  inscrito:
    "bg-emerald-100 text-emerald-700 dark:bg-emerald-900/40 dark:text-emerald-200",
  perdido: "bg-rose-100 text-rose-700 dark:bg-rose-900/40 dark:text-rose-200",
  spam: "bg-slate-200 text-slate-700 dark:bg-slate-800/60 dark:text-slate-200",
};

// Paleta de colores para gráficas
export const LEVEL_PALETTE = [
  "#7a1b33",
  "#d94468",
  "#f59e0b",
  "#10b981",
  "#0ea5e9",
];
export const LOCATION_PALETTE = [
  "#38bdf8",
  "#f59e0b",
  "#ec4899",
  "#818cf8",
  "#22c55e",
  "#f87171",
  "#4ade80",
  "#fbbf24",
  "#60a5fa",
  "#fb7185",
  "#a855f7",
  "#f97316",
];

// Colores corporativos
export const COMPANY_PRIMARY = "#b91c1c";
export const COMPANY_SECONDARY = "#f59e0b";

// Conjuntos de estados por categoría - ACTUALIZADOS PARA NUEVOS VALORES DB
export const FOLLOW_UP_STATUSES = new Set([
  "contactado",
  "cita_solicitada",
  "cita",
  "interesado",
  "entrega_resultado",
  "pendiente_pago",
]);
export const COMPLETED_STATUSES = new Set(["inscrito"]);
export const DROPOUT_STATUSES = new Set(["perdido", "spam"]);

// Utilidades
export const formatCurrencyValue = (value) =>
  `$${typeof value === "number" ? value.toLocaleString() : 0}`;

export const hexToRgba = (hex, alpha = 1) => {
  if (!hex) return `rgba(15,23,42,${alpha})`;
  const normalized = hex.replace("#", "");
  const isShort = normalized.length === 3;
  const r = parseInt(
    isShort ? normalized[0] + normalized[0] : normalized.slice(0, 2),
    16,
  );
  const g = parseInt(
    isShort ? normalized[1] + normalized[1] : normalized.slice(2, 4),
    16,
  );
  const b = parseInt(
    isShort ? normalized[2] + normalized[2] : normalized.slice(4, 6),
    16,
  );
  return `rgba(${r},${g},${b},${alpha})`;
};

export function generateMockTrend(seed, length = 6) {
  const source = String(seed || "");
  if (!source.length) return Array(length).fill(0);
  let hash = 0;
  for (let i = 0; i < source.length; i++) {
    hash = (hash * 31 + source.charCodeAt(i)) | 0;
  }
  const trend = [];
  let base = Math.abs(hash % 40) + 10;
  for (let i = 0; i < length; i++) {
    hash = (hash * 17 + i * 23) | 0;
    const delta = (hash % 9) - 4;
    base = Math.max(0, base + delta);
    trend.push(base);
  }
  return trend;
}

export function summarizePerformance({
  total,
  inscritos,
  followUp,
  conversionRate,
}) {
  if (!total) return "Sin datos suficientes para generar un análisis.";
  const rate = conversionRate || (total > 0 ? (inscritos / total) * 100 : 0);
  if (rate >= 20)
    return `Excelente desempeño con una conversión del ${rate.toFixed(1)}%. Mantén el ritmo y prioriza leads valiosos.`;
  if (rate >= 10)
    return `Buen progreso con ${inscritos} inscritos. Enfócate en leads en seguimiento para mejorar la conversión.`;
  if (followUp > 0)
    return `Tienes ${followUp} leads en seguimiento. Prioriza cerrar para aumentar tu tasa de conversión.`;
  return `Comienza a dar seguimiento a tus ${total} leads asignados para generar inscripciones.`;
}
